export default __webpack_public_path__ + "static/media/icon_donation.31415b74.svg";